export default {
  routes: [
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
      },
      component: () => import("@/view/Login"),
    },
    {
      path: "/userInfo",
      name: "UserInfo",
      meta: {
        title: "关注公众号",
      },
      component: () => import("@/view/UserInfo"),
    },
    {
      path: "/customer",
      name: "Customer",
      meta: {
        title: "联系客服",
      },
      component: () => import("@/view/Customer"),
    },
    {
      path: "*",
      name: "Customer",
      component: () => import("@/view/Customer"),
    },
  ],
  mode: "hash",
  // mode: "history"
};